import { Button, Text } from '@mantine/core';
import { IconPrinter } from '@tabler/icons-react';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React from 'react';
import { useSelector } from 'react-redux';
import { BolData } from '../../interface/BillOfLading';
import { generatePDF } from '../../Utils/generatePDF';
import { getStores } from '../../api/storeApi';
import { getStoreInfo } from '../../Utils/utils';
// client\public\svp_sports_drk_blue.png
(pdfMake.vfs as any) = pdfFonts.vfs;

interface BolPrintProps {
    bol: BolData;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    variant?: 'default' | 'outline' | 'light' | 'filled';
    textElement?: string;
}

const fonts = {
    Roboto: {
        normal: 'src/fonts/Roboto-Regular.ttf',
        bold: 'src/fonts/Roboto-Medium.ttf',
        italics: 'src/fonts/Roboto-Italic.ttf',
        bolditalics: 'src/fonts/Roboto-MediumItalic.ttf',
    },
};
const BolPrint: React.FC<BolPrintProps> = ({ bol, size, variant, textElement }) => {
    const user = useSelector((state: any) => state.user.user);
    const token = useSelector((state: any) => state.user.sessionId);
    // const logo = './letter_head.png';
    const handlePrintBol = async () => {
        try {
            if (!bol) {
                alert('Can not find the data.');
                return;
            }
            // Check the localStorage first for the store data to avoid unnecessary API calls
            const storedList = localStorage.getItem('storeList');
            if (storedList) {
                const stores = JSON.parse(storedList);
                generatePDF(bol, user, getStoreInfo('location', user.location, stores), stores);

                // Set the storeList in localStorage 
                localStorage.setItem('storeList', JSON.stringify(stores));
            } else {
                getStores().then((data) => {
                    generatePDF(bol, user, getStoreInfo('location', user.location, data), data);
                }).catch((error) => { console.log(error) })
            }
        } catch (error) {
            console.log(`Error :`, error);
        }
    }
    {/* on click copy the bol_no to clipboard*/ }
    return (
        <div style={{ cursor: 'pointer' }} onClick={() => { navigator.clipboard.writeText(bol?.bol_no) }}>
            {textElement ?
                (<Text className={'linkText'} onClick={handlePrintBol} size={size || 'sm'} fw={650} fz={14}> {textElement}</Text>) :
                (<Button className={'btn'} onClick={handlePrintBol} size={size || 'sm'} variant={variant || 'default'}> <IconPrinter /></Button>)}

        </div>
    )
}

export default BolPrint;